import { render, staticRenderFns } from "./CompanyReadme.vue?vue&type=template&id=315dacdc&scoped=true"
import script from "./CompanyReadme.vue?vue&type=script&lang=js"
export * from "./CompanyReadme.vue?vue&type=script&lang=js"
import style0 from "./CompanyReadme.vue?vue&type=style&index=0&id=315dacdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315dacdc",
  null
  
)

export default component.exports